import { NavigationContext } from '@/app/modules/Context/NavigationContextProvider';
import { USER_PROFILE_SUB_NAVIGATION_LIST } from '@/app/modules/LandingHeader/config';
import { MobileUserNavLinks } from '@/app/modules/LandingHeaderV2/components/MobileUserNavLinks/MobileUserNavLinks';
import { appClientConfig } from '@/app/utils/appClientConfig';
import { NavDropdown } from '@/modules/LandingHeaderV2/components/NavDropdown/NavDropdown';
import { NavLink } from '@/modules/LandingHeaderV2/components/NavLink/NavLink';
import { useUserDisplayInfo } from '@/modules/LandingHeaderV2/hooks/useUserDisplayInfo';
import cx from 'classnames';
import { useContext, useEffect, useState } from 'react';

import styles from './NavMenuList.module.scss';

export interface NavMenuListProps {
  isMobileNavActive: boolean;
  signInUrl?: string;
  registerUrl?: string;
  onSignInClick?: () => void;
  setisMobileNavActive?: () => void;
  isSmallScreen: boolean;
}

export const NavMenuList = ({
  isMobileNavActive,
  signInUrl,
  registerUrl,
  onSignInClick,
  setisMobileNavActive,
  isSmallScreen,
}: NavMenuListProps) => {
  const navigationContextList = useContext(NavigationContext);
  const [navMenuList, setNaveMenuList] = useState(navigationContextList);

  const { isUserLoggedIn, userInitials } = useUserDisplayInfo();
  const shouldAddMyProfileDropdown =
    navigationContextList.length && isUserLoggedIn && isSmallScreen;

  useEffect(() => {
    if (shouldAddMyProfileDropdown) {
      setNaveMenuList([
        navigationContextList[0],
        {
          label: 'My Profile',
          to: appClientConfig.practitionerProfileUrl ?? '',
          subItems: USER_PROFILE_SUB_NAVIGATION_LIST,
          isLoggedInDropdown: true,
          userInitials,
        },
        ...navigationContextList.slice(1),
      ]);
    } else {
      setNaveMenuList(navigationContextList);
    }
  }, [navigationContextList, shouldAddMyProfileDropdown, userInitials]);

  if (!navigationContextList.length) {
    return null;
  }

  return (
    <nav
      className={cx(styles.navContainer, isMobileNavActive && styles.mobileNavContainerActive)}
      aria-label="Top navigation"
      data-testid="nav-menu-list"
    >
      {navMenuList.map(navItem => {
        return navItem.subItems && navItem.subItems.length > 0 ? (
          <NavDropdown
            key={navItem.id}
            label={navItem.label}
            testid={navItem.testid}
            subItems={navItem.subItems}
            to={navItem.to}
            onNavItemClick={setisMobileNavActive}
            isSmallScreen={isSmallScreen}
          />
        ) : (
          <NavLink
            key={navItem.id}
            label={navItem.label}
            to={navItem.to}
            trackEventName={navItem.trackEventName}
            testid={navItem.testid}
          />
        );
      })}
      <MobileUserNavLinks
        isSmallScreen={isSmallScreen}
        onSignInClick={onSignInClick}
        signInUrl={signInUrl}
        registerUrl={registerUrl}
        isUserLoggedIn={isUserLoggedIn}
      />
    </nav>
  );
};
